import { useSyncExternalStore } from 'react';

let inlineFullscreenCount = 0;
const listeners = new Set<() => void>();

/** Notify React subscribers that inline fullscreen activity changed. */
function notifyInlineFullscreenListeners() {
    for (const listener of listeners) {
        listener();
    }
}

/** Whether any inline fullscreen node view is currently open. */
export function isInlineFullscreenActive(): boolean {
    return inlineFullscreenCount > 0;
}

/** Subscribe to inline fullscreen count changes (for useSyncExternalStore). */
function subscribeInlineFullscreen(onStoreChange: () => void): () => void {
    listeners.add(onStoreChange);
    return () => {
        listeners.delete(onStoreChange);
    };
}

/**
 * Call while an inline fullscreen node view is open.
 * Returns an unregister function for cleanup.
 */
export function registerInlineFullscreen(): () => void {
    inlineFullscreenCount += 1;
    notifyInlineFullscreenListeners();
    return () => {
        inlineFullscreenCount = Math.max(0, inlineFullscreenCount - 1);
        notifyInlineFullscreenListeners();
    };
}

/** React hook that re-renders when inline fullscreen activity changes. */
export function useInlineFullscreenActive(): boolean {
    return useSyncExternalStore(subscribeInlineFullscreen, isInlineFullscreenActive, () => false);
}
